if (!customElements.get('cart-remove-button')) {
  customElements.define(
    'cart-remove-button',
    class CartRemoveButton extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          event.preventDefault();
          const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
          cartItems.updateQuantity(this.dataset.index, 0, event);
        });
      }
    }
  );
}

if (!customElements.get('cart-items')) {
  customElements.define(
    'cart-items',
    class CartItems extends HTMLElement {
      constructor() {
        super();

        this.lineItemStatusElement =
          document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

        const debouncedOnChange = debounce((event) => {
          this.onChange(event);
        }, 300);

        this.addEventListener('change', debouncedOnChange.bind(this));
      }

      onChange(event) {
        console.log('[cart-items.onChange] イベントデータ', {
          index: event.target.dataset.index,
          value: event.target.value,
          activeName: document.activeElement?.getAttribute('name')
        });
        this.updateQuantity(
          event.target.dataset.index,
          event.target.value,
          event,
          document.activeElement?.getAttribute('name')
        );
      }

      updateQuantity(line, quantity, event, name) {
        this.enableLoading(line);

        const body = JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });

        console.log('[updateQuantity] 送信内容', { line, quantity, body });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
          .then((response) => response.text())
          .then((state) => {
            const parsedState = JSON.parse(state);
            if (parsedState.errors) {
              this.updateLiveRegions(line, parsedState.errors);
              return;
            }

            this.getSectionsToRender().forEach((section) => {
              const htmlFromResponse = parsedState.sections[section.section];
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

              console.log('--- セクション確認 ---');
              console.log('section.section:', section.section);
              console.log('section.id:', section.id);
              console.log('section.selector:', section.selector);
              console.log('parsed HTML:', htmlFromResponse);
              console.log('elementToReplace:', elementToReplace);

              if (htmlFromResponse && elementToReplace) {
                elementToReplace.innerHTML = this.getSectionInnerHTML(htmlFromResponse, section.selector);
              } else {
                console.warn(`セクション更新スキップ: ${section.section} - データまたは置換先が見つかりません`);
              }
            });

            this.updateLiveRegions(line, '');
          })
          .catch(() => {
//            const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
//            if (errors) errors.textContent = window.cartStrings.error;
          })
          .finally(() => {
            this.disableLoading(line);
            location.reload(); 
          });
      }

      getSectionsToRender() {
        return [
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items').dataset.id,
            selector: '.js-contents',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'cart-live-region-text',
            section: 'cart-live-region-text',
            selector: '.shopify-section',
          },
          {
            id: 'main-cart-footer',
            section: document.getElementById('main-cart-footer').dataset.id,
            selector: '.js-contents',
          },
        ];
      }

      getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
      }

      updateLiveRegions(line, message) {
        const lineItemError =
          document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
        if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

        this.lineItemStatusElement.setAttribute('aria-hidden', true);

        const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
        if (cartStatus) {
          cartStatus.setAttribute('aria-hidden', false);
          setTimeout(() => cartStatus.setAttribute('aria-hidden', true), 1000);
        }
      }

      enableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');

        const overlays = [
          ...this.querySelectorAll(`#CartItem-${line} .loading__spinner`),
          ...this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`)
        ];
        overlays.forEach((overlay) => overlay.classList.remove('hidden'));

        document.activeElement?.blur();
        if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
      }

      disableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');

        const overlays = [
          ...this.querySelectorAll(`#CartItem-${line} .loading__spinner`),
          ...this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`)
        ];
        overlays.forEach((overlay) => overlay.classList.add('hidden'));
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', function () {
  // Shopifyの自動バインドによるchangeイベントを外す
  document.querySelectorAll('.quantity__input').forEach(input => {
    const newInput = input.cloneNode(true);
    input.parentNode.replaceChild(newInput, input);
  });

  // プラス・マイナスボタン
  document.querySelectorAll('.quantity__button').forEach(btn => {
    btn.addEventListener('click', event => {
      event.preventDefault();
      const input = btn.closest('.quantity').querySelector('.quantity__input');
      const currentVal = parseInt(input.value, 10);
      const min = parseInt(input.getAttribute('min')) || 1;
      const max = parseInt(input.getAttribute('max')) || 9999;
      const index = input.dataset.index;
      let newVal = currentVal;

      if (btn.name === 'plus') {
        newVal = Math.min(currentVal + 1, max);
      } else if (btn.name === 'minus') {
        newVal = Math.max(currentVal - 1, min);
      }

      if (newVal !== currentVal) {
        console.log('[クリック] 確定更新 newVal:', newVal);
        input.value = newVal;

        const cartItems = document.querySelector('cart-items');
        if (cartItems) {
          cartItems.updateQuantity(index, newVal, event, btn.name);
        } else {
          console.error('cart-items要素が見つかりません');
        }
      }
    });
  });

  // 数値を手入力で変更した場合
  document.querySelectorAll('.quantity__input').forEach(input => {
    input.addEventListener('change', event => {
      const currentVal = parseInt(input.value, 10);
      const min = parseInt(input.getAttribute('min')) || 1;
      const max = parseInt(input.getAttribute('max')) || 9999;
      const index = input.dataset.index;
      let newVal = currentVal;

      // 入力が範囲外なら補正
      if (newVal < min) newVal = min;
      if (newVal > max) newVal = max;

      console.log('[手入力] 確定更新 newVal:', newVal);
      input.value = newVal;

      const cartItems = document.querySelector('cart-items');
      if (cartItems) {
        cartItems.updateQuantity(index, newVal, event, 'manual');
      } else {
        console.error('cart-items要素が見つかりません');
      }
    });
  });
});